import { Observable } from 'rxjs';

import { MeasGroup, MeasGroupListResponse, MeasGroupQueryParams } from '../models/meas-group.model';

export abstract class MeasGroupGateway {
  abstract listMeasGroups(params: MeasGroupQueryParams): Observable<MeasGroupListResponse<MeasGroup>>;
}
